import { ISession, IUserInfo } from 'app/models';
import configuration from '../configuration';
import * as naming from '../naming';
import { IRequest, WebClient } from './web';

const { OPENID_URL, OPENID_REALM, OPENID_CLIENT, OPENID_SCOPE } = configuration;

export class OpenIDClient extends WebClient {
  constructor() {
    super({ baseURL: `${OPENID_URL}/realms/${OPENID_REALM}/protocol/openid-connect`, authenticate: true });

    const forms = ['token', 'revoke'];
    this.client.interceptors.request.use((request) => {
      if (forms.includes(request.url!)) {
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
        request.data.client_id = OPENID_CLIENT;
      }

      return request;
    });
  }

  private async token(data: any, config?: IRequest): Promise<ISession> {
    return this.post<any>('token', data, config).then(session => naming.camel(session) as ISession);
  }

  public async access(credentials: any, config?: IRequest): Promise<ISession> {
    return this.token({ ...credentials,
      grant_type: 'password',
      scope: OPENID_SCOPE,
    }, config);
  }
  public async refresh(token: string, config?: IRequest): Promise<ISession> {
    return this.token({
      refresh_token: token,
      grant_type: 'refresh_token',
    }, config);
  }

  public async revoke(token: string, type: string, config?: IRequest): Promise<any> {
    return this.post('revoke', { token,
      token_type_hint: type,
    }, config);
  }
  public async userInfo(config?: IRequest): Promise<IUserInfo> {
    return this.get<any>('userinfo', config).then(userinfo => (naming.camel(userinfo) as IUserInfo));
  }
}

export const OpenID = new OpenIDClient();
